const GlobalMetaforaLogo = ({ size = 200, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {/* Gradiente principal azul */}
        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
        
        {/* Gradiente secundario cyan */}
        <linearGradient id="cyanGradient" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
        
        {/* Gradiente para el brillo */}
        <linearGradient id="glowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#93c5fd" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.2" />
        </linearGradient>

        {/* Filtro de brillo */}
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>

        {/* Filtro sombra */}
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="#3b82f6" floodOpacity="0.4"/>
        </filter>
      </defs>

      {/* Círculo exterior - Representa lo GLOBAL */}
      <circle
        cx="100"
        cy="100"
        r="90"
        stroke="url(#blueGradient)"
        strokeWidth="2"
        fill="none"
        opacity="0.3"
      />

      {/* Órbitas - Conexiones globales */}
      <ellipse
        cx="100"
        cy="100"
        rx="75"
        ry="30"
        stroke="url(#cyanGradient)"
        strokeWidth="1.5"
        fill="none"
        opacity="0.5"
        transform="rotate(-30 100 100)"
      />
      <ellipse
        cx="100"
        cy="100"
        rx="75"
        ry="30"
        stroke="url(#cyanGradient)"
        strokeWidth="1.5"
        fill="none"
        opacity="0.5"
        transform="rotate(30 100 100)"
      />
      <ellipse
        cx="100"
        cy="100"
        rx="75"
        ry="30"
        stroke="url(#cyanGradient)"
        strokeWidth="1.5"
        fill="none"
        opacity="0.5"
        transform="rotate(90 100 100)"
      />

      {/* Hexágono central - Representa tecnología y estructura */}
      <polygon
        points="100,35 145,60 145,110 100,135 55,110 55,60"
        fill="url(#blueGradient)"
        filter="url(#shadow)"
      />

      {/* Hexágono interno brillante */}
      <polygon
        points="100,50 132,68 132,102 100,120 68,102 68,68"
        fill="url(#glowGradient)"
        opacity="0.6"
      />

      {/* La "G" estilizada - GLOBAL METAFORA */}
      <g filter="url(#glow)">
        {/* Parte exterior de la G */}
        <path
          d="M115 70 
             C115 70 130 75 130 90 
             C130 105 120 115 100 115 
             C80 115 70 105 70 85 
             C70 65 85 55 105 55
             L105 62
             C90 62 78 70 78 85
             C78 100 88 108 100 108
             C112 108 122 100 122 90
             C122 82 118 78 110 78
             L110 85
             L100 85
             L100 70
             L115 70Z"
          fill="white"
        />
        
        {/* Flecha de la G - Representa transformación/progreso */}
        <path
          d="M100 85 L115 85 L115 78 L125 88 L115 98 L115 92 L100 92 Z"
          fill="#06b6d4"
        />
      </g>

      {/* Nodos de conexión - Red global */}
      <circle cx="100" cy="25" r="4" fill="#60a5fa" filter="url(#glow)" />
      <circle cx="165" cy="65" r="4" fill="#06b6d4" filter="url(#glow)" />
      <circle cx="165" cy="135" r="4" fill="#60a5fa" filter="url(#glow)" />
      <circle cx="100" cy="175" r="4" fill="#06b6d4" filter="url(#glow)" />
      <circle cx="35" cy="135" r="4" fill="#60a5fa" filter="url(#glow)" />
      <circle cx="35" cy="65" r="4" fill="#06b6d4" filter="url(#glow)" />

      {/* Líneas de conexión a los nodos */}
      <line x1="100" y1="35" x2="100" y2="25" stroke="#60a5fa" strokeWidth="1" opacity="0.6" />
      <line x1="145" y1="60" x2="165" y2="65" stroke="#06b6d4" strokeWidth="1" opacity="0.6" />
      <line x1="145" y1="110" x2="165" y2="135" stroke="#60a5fa" strokeWidth="1" opacity="0.6" />
      <line x1="100" y1="135" x2="100" y2="175" stroke="#06b6d4" strokeWidth="1" opacity="0.6" />
      <line x1="55" y1="110" x2="35" y2="135" stroke="#60a5fa" strokeWidth="1" opacity="0.6" />
      <line x1="55" y1="60" x2="35" y2="65" stroke="#06b6d4" strokeWidth="1" opacity="0.6" />

      {/* Puntos brillantes decorativos */}
      <circle cx="75" cy="45" r="2" fill="#93c5fd" opacity="0.8" />
      <circle cx="125" cy="45" r="2" fill="#93c5fd" opacity="0.8" />
      <circle cx="150" cy="85" r="2" fill="#93c5fd" opacity="0.8" />
      <circle cx="125" cy="125" r="2" fill="#93c5fd" opacity="0.8" />
      <circle cx="75" cy="125" r="2" fill="#93c5fd" opacity="0.8" />
      <circle cx="50" cy="85" r="2" fill="#93c5fd" opacity="0.8" />
    </svg>
  );
};

export default GlobalMetaforaLogo;
